import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#333333', // Gris oscuro metálico
      light: '#555555',
      dark: '#111111',
    },
    secondary: {
      main: '#757575', // Gris plateado
      light: '#9e9e9e',
      dark: '#494949',
    },
    background: {
      default: '#f0f0f0', // Gris claro similar al panel plateado
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
    error: {
      main: '#d32f2f',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#212121', // Negro similar al panel superior
        },
      },
    },
  },
}); 